module.exports = __webpack_public_path__ + "img/ADDRESS.f2aa807b.svg";